import React, { useState, useEffect, useCallback } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const fmt = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);
const MESES = ['','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const TIPOS_RED = ['fibra','radio','cable','satelite','otro'];

export default function ProveedoresRed() {
  const { usuario } = useAuth();
  const hoy = new Date();
  const [vista, setVista]               = useState('lista');
  const [proveedores, setProveedores]   = useState([]);
  const [seleccionado, setSel]          = useState(null);
  const [clientes, setClientes]         = useState([]);
  const [cobros, setCobros]             = useState([]);
  const [clientesDisp, setClientesDisp] = useState([]);
  const [modal, setModal]               = useState(false);
  const [editando, setEditando]         = useState(null);
  const [modalPago, setModalPago]       = useState(null);
  const [clienteAsignar, setClienteAsignar] = useState('');
  const [tabDetalle, setTabDetalle]     = useState('clientes');
  const [rentabilidad, setRentabilidad] = useState([]);
  const [genMes, setGenMes]             = useState({ mes: hoy.getMonth()+1, anio: hoy.getFullYear() });
  const [mesCobros, setMesCobros]       = useState({ mes: hoy.getMonth()+1, anio: hoy.getFullYear() });
  const [cargando, setCargando]         = useState(false);
  const [msg, setMsg]                   = useState('');
  const [form, setForm] = useState({ nombre:'', contacto:'', telefono:'', email:'', tipo_red:'fibra', tarifa_por_cliente:'', dia_pago:1, notas:'' });

  const esAdmin = ['admin','superadmin'].includes(usuario?.rol);

  const cargar = useCallback(async () => {
    const r = await api.get('/api/proveedores-red');
    setProveedores(r.data);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => { api.get('/api/clientes').then(r => setClientesDisp(r.data.clientes || r.data)); }, []);

  const verDetalle = async (prov) => {
    setSel(prov);
    setTabDetalle('clientes');
    const [det, cob, rent] = await Promise.all([
      api.get(`/api/proveedores-red/${prov.id}`),
      api.get(`/api/proveedores-red/cobros?mes=${mesCobros.mes}&anio=${mesCobros.anio}`),
      api.get('/api/reportes/rentabilidad-proveedores-red'),
    ]);
    setClientes(det.data.clientes || []);
    setCobros(cob.data.filter(c => c.proveedor_id === prov.id || c.proveedor_nombre === prov.nombre));
    const miRent = rent.data.find(r => r.proveedor_id === prov.id);
    setRentabilidad(miRent || null);
    setVista('detalle');
  };

  const abrirModal = (prov=null) => {
    if (prov) {
      setForm({ nombre:prov.nombre, contacto:prov.contacto||'', telefono:prov.telefono||'', email:prov.email||'', tipo_red:prov.tipo_red||'fibra', tarifa_por_cliente:prov.tarifa_por_cliente, dia_pago:prov.dia_pago||1, notas:prov.notas||'' });
      setEditando(prov);
    } else {
      setForm({ nombre:'', contacto:'', telefono:'', email:'', tipo_red:'fibra', tarifa_por_cliente:'', dia_pago:1, notas:'' });
      setEditando(null);
    }
    setMsg(''); setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre || !form.tarifa_por_cliente) return setMsg('Nombre y tarifa son obligatorios');
    setCargando(true);
    try {
      const payload = { ...form, tarifa_por_cliente: parseFloat(form.tarifa_por_cliente), dia_pago: parseInt(form.dia_pago)||1 };
      if (editando) await api.put(`/api/proveedores-red/${editando.id}`, payload);
      else await api.post('/api/proveedores-red', payload);
      setModal(false); cargar();
      if (seleccionado) verDetalle({ ...seleccionado, ...payload });
      setMsg('');
    } catch(e) { setMsg(e.response?.data?.error || 'Error al guardar'); }
    setCargando(false);
  };

  const asignarCliente = async () => {
    if (!clienteAsignar) return;
    try {
      await api.post(`/api/proveedores-red/${seleccionado.id}/clientes`, { cliente_id: clienteAsignar });
      setClienteAsignar('');
      const det = await api.get(`/api/proveedores-red/${seleccionado.id}`);
      setClientes(det.data.clientes || []);
      cargar();
    } catch(e) { alert(e.response?.data?.error || 'Error'); }
  };

  const desasignarCliente = async (clienteId) => {
    if (!window.confirm('¿Retirar este cliente de la red del proveedor?')) return;
    try {
      await api.delete(`/api/proveedores-red/${seleccionado.id}/clientes/${clienteId}`);
      const det = await api.get(`/api/proveedores-red/${seleccionado.id}`);
      setClientes(det.data.clientes || []);
      cargar();
    } catch(e) { alert('Error'); }
  };

  const generarCobro = async () => {
    setCargando(true);
    try {
      const r = await api.post(`/api/proveedores-red/${seleccionado.id}/generar-cobro`, genMes);
      alert(r.data.mensaje);
      const cob = await api.get(`/api/proveedores-red/cobros?mes=${genMes.mes}&anio=${genMes.anio}`);
      setCobros(cob.data.filter(c => c.proveedor_id === seleccionado.id || c.proveedor_nombre === seleccionado.nombre));
    } catch(e) { alert(e.response?.data?.error || 'Error'); }
    setCargando(false);
  };

  const registrarPago = async () => {
    try {
      await api.put(`/api/proveedores-red/cobros/${modalPago.id}/pagar`, {
        monto_pagado: modalPago.monto_total,
        fecha_pago: modalPago.fecha_pago,
      });
      setModalPago(null);
      const cob = await api.get(`/api/proveedores-red/cobros?mes=${mesCobros.mes}&anio=${mesCobros.anio}`);
      setCobros(cob.data.filter(c => c.proveedor_id === seleccionado?.id || c.proveedor_nombre === seleccionado?.nombre));
      cargar();
    } catch(e) { alert('Error al registrar pago'); }
  };

  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const cs = {
    page:  { padding:'24px', maxWidth:'1200px', margin:'0 auto' },
    card:  { background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'12px', padding:'20px', marginBottom:'16px' },
    h1:    { fontSize:'22px', fontWeight:'700', margin:'0 0 20px', color:'#fff' },
    h2:    { fontSize:'16px', fontWeight:'700', margin:'0 0 14px', color:'rgba(255,255,255,0.9)' },
    btn:   { padding:'8px 16px', borderRadius:'8px', border:'none', cursor:'pointer', fontWeight:'600', fontSize:'13px' },
    btnP:  { background:'#2563EB', color:'#fff' },
    btnG:  { background:'#16A34A', color:'#fff' },
    btnR:  { background:'rgba(239,68,68,0.15)', border:'1px solid rgba(239,68,68,0.2)', color:'#FCA5A5' },
    btnW:  { background:'rgba(255,255,255,0.1)', color:'rgba(255,255,255,0.85)' },
    btnO:  { background:'rgba(245,158,11,0.2)', border:'1px solid rgba(245,158,11,0.3)', color:'#FCD34D' },
    badge: { padding:'3px 10px', borderRadius:'20px', fontSize:'12px', fontWeight:'600' },
    input: { width:'100%', padding:'9px 12px', borderRadius:'8px', border:'1px solid rgba(255,255,255,0.12)', fontSize:'14px', boxSizing:'border-box', background:'rgba(255,255,255,0.06)', color:'rgba(255,255,255,0.9)', outline:'none', fontFamily:'inherit' },
    label: { fontSize:'12px', fontWeight:'600', color:'rgba(255,255,255,0.5)', display:'block', marginBottom:'4px' },
    grid2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' },
    table: { width:'100%', borderCollapse:'collapse' },
    th:    { textAlign:'left', padding:'10px 12px', fontSize:'12px', fontWeight:'700', color:'rgba(255,255,255,0.45)', borderBottom:'2px solid rgba(255,255,255,0.1)', textTransform:'uppercase', letterSpacing:'0.5px' },
    td:    { padding:'12px', fontSize:'13px', borderBottom:'1px solid rgba(255,255,255,0.05)', verticalAlign:'middle', color:'rgba(255,255,255,0.8)' },
  };

  // ── VISTA LISTA ─────────────────────────────────────────────
  if (vista === 'lista') return (
    <Layout>
    <div style={cs.page}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px', flexWrap:'wrap', gap:'10px' }}>
        <h1 style={{ fontSize:'22px', fontWeight:'700', margin:0, color:'#fff' }}>🌐 Proveedores de Red</h1>
        {esAdmin && (
          <button style={{...cs.btn,...cs.btnP}} onClick={()=>abrirModal()}>+ Nuevo proveedor</button>
        )}
      </div>

      {/* Lista de proveedores */}
      <div style={cs.card}>
        {proveedores.length === 0 ? (
          <div style={{ textAlign:'center', padding:'40px', color:'rgba(255,255,255,0.3)' }}>
            <div style={{ fontSize:'40px', marginBottom:'10px' }}>🌐</div>
            <p>No hay proveedores de red registrados</p>
          </div>
        ) : (
          <table style={cs.table}>
            <thead><tr>
              <th style={cs.th}>Proveedor</th>
              <th style={cs.th}>Contacto</th>
              <th style={cs.th}>Tipo de red</th>
              <th style={cs.th}>Tarifa/cliente</th>
              <th style={cs.th}>Clientes activos</th>
              <th style={cs.th}>Costo mensual</th>
              <th style={cs.th}>Estado</th>
              <th style={cs.th}>Acciones</th>
            </tr></thead>
            <tbody>
              {proveedores.map(p=>(
                <tr key={p.id} style={{ cursor:'pointer' }} onClick={()=>verDetalle(p)}>
                  <td style={cs.td}>
                    <strong style={{color:'#fff'}}>{p.nombre}</strong>
                    {p.email && <div style={{fontSize:'12px',color:'rgba(255,255,255,0.4)'}}>{p.email}</div>}
                  </td>
                  <td style={cs.td}>
                    {p.contacto && <div>{p.contacto}</div>}
                    {p.telefono && <div style={{fontSize:'12px',color:'rgba(255,255,255,0.4)'}}>{p.telefono}</div>}
                  </td>
                  <td style={cs.td}>
                    <span style={{...cs.badge, background:'rgba(99,102,241,0.15)', color:'#A5B4FC'}}>
                      {p.tipo_red}
                    </span>
                  </td>
                  <td style={cs.td}>{fmt(p.tarifa_por_cliente)}</td>
                  <td style={cs.td}><strong>{p.clientes_activos || 0}</strong></td>
                  <td style={cs.td}>
                    <strong style={{color:'#F59E0B'}}>
                      {fmt((p.clientes_activos||0) * p.tarifa_por_cliente)}
                    </strong>
                  </td>
                  <td style={cs.td}>
                    <span style={{...cs.badge, background:p.activo?'rgba(34,197,94,0.1)':'rgba(107,114,128,0.1)', color:p.activo?'#22C55E':'#9CA3AF'}}>
                      {p.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td style={cs.td} onClick={e=>e.stopPropagation()}>
                    <div style={{display:'flex', gap:'6px'}}>
                      {esAdmin && <button style={{...cs.btn,...cs.btnW,padding:'5px 10px'}} onClick={()=>abrirModal(p)}>✏️</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Modal crear/editar */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto'}}>
            <h2 style={{fontSize:'16px',fontWeight:'700',marginBottom:'20px',color:'#fff'}}>{editando?'Editar proveedor':'Nuevo proveedor de red'}</h2>
            {msg && <div style={{background:'rgba(239,68,68,0.1)',color:'#FCA5A5',padding:'10px',borderRadius:'8px',marginBottom:'14px',fontSize:'13px'}}>{msg}</div>}
            <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
              <div><label style={cs.label}>Nombre *</label><input style={cs.input} value={form.nombre} onChange={e=>f('nombre',e.target.value)} placeholder="Ej: Claro, ETB, proveedor local"/></div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Contacto</label><input style={cs.input} value={form.contacto} onChange={e=>f('contacto',e.target.value)}/></div>
                <div><label style={cs.label}>Teléfono</label><input style={cs.input} value={form.telefono} onChange={e=>f('telefono',e.target.value)}/></div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Email</label><input style={cs.input} type="email" value={form.email} onChange={e=>f('email',e.target.value)}/></div>
                <div>
                  <label style={cs.label}>Tipo de red</label>
                  <select style={cs.input} value={form.tipo_red} onChange={e=>f('tipo_red',e.target.value)}>
                    {TIPOS_RED.map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                  </select>
                </div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Tarifa por cliente ($/mes) *</label><input style={cs.input} type="number" value={form.tarifa_por_cliente} onChange={e=>f('tarifa_por_cliente',e.target.value)}/></div>
                <div><label style={cs.label}>Día de pago</label><input style={cs.input} type="number" min="1" max="28" value={form.dia_pago} onChange={e=>f('dia_pago',+e.target.value)}/></div>
              </div>
              <div><label style={cs.label}>Notas</label><textarea style={{...cs.input,minHeight:'70px',resize:'vertical'}} value={form.notas} onChange={e=>f('notas',e.target.value)}/></div>
            </div>
            <div style={{display:'flex',gap:'10px',marginTop:'20px',justifyContent:'flex-end'}}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>{setModal(false);setMsg('');}}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnP}} onClick={guardar} disabled={cargando}>{cargando?'Guardando...':'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal pago */}
      {modalPago && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'400px'}}>
            <h2 style={{fontSize:'16px',fontWeight:'700',marginBottom:'16px',color:'#fff'}}>💳 Registrar pago</h2>
            <p style={{fontSize:'14px',color:'rgba(255,255,255,0.85)',marginBottom:'16px'}}>
              <strong>{modalPago.proveedor_nombre}</strong> — {MESES[modalPago.periodo_mes]} {modalPago.periodo_anio}<br/>
              <span style={{fontSize:'18px',fontWeight:'700',color:'#F59E0B'}}>{fmt(modalPago.monto_total)}</span>
            </p>
            <div><label style={cs.label}>Fecha de pago</label>
              <input type="date" style={cs.input} value={modalPago.fecha_pago} onChange={e=>setModalPago(p=>({...p,fecha_pago:e.target.value}))}/>
            </div>
            <div style={{display:'flex',gap:'10px',marginTop:'20px',justifyContent:'flex-end'}}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>setModalPago(null)}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnG}} onClick={registrarPago}>✓ Confirmar pago</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );

  // ── VISTA DETALLE ────────────────────────────────────────────
  return (
    <Layout>
    <div style={cs.page}>
      <button style={{...cs.btn,...cs.btnW,marginBottom:'16px'}} onClick={()=>setVista('lista')}>← Volver</button>

      {/* Header proveedor */}
      <div style={{...cs.card,display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:'12px'}}>
        <div>
          <h1 style={{fontSize:'22px',fontWeight:'700',margin:'0 0 6px',color:'#fff'}}>{seleccionado?.nombre}</h1>
          {seleccionado?.tipo_red && <div style={{fontSize:'13px',color:'rgba(255,255,255,0.45)'}}>🌐 {seleccionado.tipo_red}</div>}
          {seleccionado?.telefono && <div style={{fontSize:'13px',color:'rgba(255,255,255,0.45)'}}>📞 {seleccionado.telefono}</div>}
          {seleccionado?.contacto && <div style={{fontSize:'13px',color:'rgba(255,255,255,0.45)'}}>👤 {seleccionado.contacto}</div>}
          {seleccionado?.notas && <div style={{fontSize:'13px',color:'rgba(255,255,255,0.4)',marginTop:'6px',fontStyle:'italic'}}>{seleccionado.notas}</div>}
        </div>
        <div style={{display:'flex',gap:'8px'}}>
          {esAdmin && <button style={{...cs.btn,...cs.btnW}} onClick={()=>abrirModal(seleccionado)}>✏️ Editar</button>}
        </div>
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))',gap:'14px',marginBottom:'16px'}}>
        {[
          { label:'Tarifa por cliente', valor: fmt(seleccionado?.tarifa_por_cliente), color:'#2563EB' },
          { label:'Clientes en red', valor: clientes.filter(c=>c.en_red).length, color:'#16A34A' },
          { label:'Costo estimado mes', valor: fmt(clientes.filter(c=>c.en_red).length * (seleccionado?.tarifa_por_cliente||0)), color:'#F59E0B' },
          { label:'Total clientes', valor: clientes.length, color:'rgba(255,255,255,0.45)' },
        ].map(stat=>(
          <div key={stat.label} style={{...cs.card,textAlign:'center',marginBottom:0}}>
            <div style={{fontSize:'22px',fontWeight:'800',color:stat.color}}>{stat.valor}</div>
            <div style={{fontSize:'12px',color:'rgba(255,255,255,0.45)',marginTop:'4px'}}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:'0',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'4px',marginBottom:'16px',width:'fit-content'}}>
        {[['clientes','👥 Clientes'],['cobros','💳 Cobros'],['rentabilidad','💰 Rentabilidad']].map(([v,l])=>(
          <button key={v} style={{...cs.btn,...(tabDetalle===v?{background:'rgba(255,255,255,0.08)',color:'#fff'}:{background:'none',color:'rgba(255,255,255,0.45)'})}} onClick={()=>setTabDetalle(v)}>{l}</button>
        ))}
      </div>

      {/* Tab clientes */}
      {tabDetalle==='clientes' && (
        <div style={cs.card}>
          <h2 style={cs.h2}>Clientes en la red del proveedor</h2>
          {/* Asignar cliente */}
          {esAdmin && (
            <div style={{display:'flex',gap:'10px',marginBottom:'16px'}}>
              <select style={{...cs.input,flex:1}} value={clienteAsignar} onChange={e=>setClienteAsignar(e.target.value)}>
                <option value="">Seleccionar cliente para asignar...</option>
                {clientesDisp.filter(c=>!clientes.find(pc=>pc.id===c.id&&pc.en_red)).map(c=>(
                  <option key={c.id} value={c.id}>{c.nombre}</option>
                ))}
              </select>
              <button style={{...cs.btn,...cs.btnP}} onClick={asignarCliente} disabled={!clienteAsignar}>+ Asignar</button>
            </div>
          )}
          {clientes.filter(c=>c.en_red).length === 0 ? (
            <p style={{color:'rgba(255,255,255,0.3)',textAlign:'center',padding:'30px'}}>No hay clientes asignados a esta red</p>
          ) : (
            <table style={cs.table}>
              <thead><tr>
                <th style={cs.th}>Cliente</th><th style={cs.th}>Plan</th>
                <th style={cs.th}>Estado</th><th style={cs.th}>Desde</th>
                {esAdmin && <th style={cs.th}>Acción</th>}
              </tr></thead>
              <tbody>
                {clientes.filter(c=>c.en_red).map(c=>(
                  <tr key={c.id}>
                    <td style={cs.td}><strong style={{color:'#fff'}}>{c.nombre}</strong>{c.telefono&&<div style={{fontSize:'12px',color:'rgba(255,255,255,0.4)'}}>{c.telefono}</div>}</td>
                    <td style={cs.td}>{c.plan_nombre||<span style={{color:'rgba(255,255,255,0.3)'}}>Sin plan</span>}</td>
                    <td style={cs.td}>
                      <span style={{...cs.badge,background:c.estado==='activo'?'rgba(34,197,94,0.1)':'rgba(239,68,68,0.1)',color:c.estado==='activo'?'#22C55E':'#FCA5A5'}}>
                        {c.estado}
                      </span>
                    </td>
                    <td style={cs.td}>{c.fecha_inicio?new Date(c.fecha_inicio).toLocaleDateString('es-CO'):'-'}</td>
                    {esAdmin && <td style={cs.td}>
                      <button style={{...cs.btn,...cs.btnR,padding:'5px 10px',fontSize:'12px'}} onClick={()=>desasignarCliente(c.id)}>Retirar</button>
                    </td>}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab cobros */}
      {tabDetalle==='cobros' && (
        <div style={cs.card}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px',flexWrap:'wrap',gap:'10px'}}>
            <h2 style={{...cs.h2,margin:0}}>Cobros al proveedor</h2>
            {esAdmin && (
              <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
                <select style={{...cs.input,width:'auto',padding:'6px 10px'}} value={genMes.mes} onChange={e=>setGenMes(p=>({...p,mes:+e.target.value}))}>
                  {MESES.slice(1).map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                </select>
                <input type="number" style={{...cs.input,width:'85px',padding:'6px 10px'}} value={genMes.anio} onChange={e=>setGenMes(p=>({...p,anio:+e.target.value}))}/>
                <button style={{...cs.btn,...cs.btnG}} onClick={generarCobro} disabled={cargando}>
                  {cargando?'Generando...':'⚡ Generar cobro'}
                </button>
              </div>
            )}
          </div>
          {cobros.length === 0 ? (
            <p style={{color:'rgba(255,255,255,0.3)',textAlign:'center',padding:'30px'}}>No hay cobros generados aún</p>
          ) : (
            <table style={cs.table}>
              <thead><tr>
                <th style={cs.th}>Período</th><th style={cs.th}>Clientes</th>
                <th style={cs.th}>Tarifa</th><th style={cs.th}>Total</th>
                <th style={cs.th}>Estado</th><th style={cs.th}>Fecha pago</th>
                {esAdmin && <th style={cs.th}>Acción</th>}
              </tr></thead>
              <tbody>
                {cobros.map(co=>(
                  <tr key={co.id}>
                    <td style={cs.td}><strong style={{color:'#fff'}}>{MESES[co.periodo_mes]} {co.periodo_anio}</strong></td>
                    <td style={cs.td}>{co.num_clientes}</td>
                    <td style={cs.td}>{fmt(co.tarifa_unitaria)}</td>
                    <td style={cs.td}><strong style={{color:'#F59E0B'}}>{fmt(co.monto_total)}</strong></td>
                    <td style={cs.td}>
                      <span style={{...cs.badge,background:co.estado==='pagado'?'rgba(34,197,94,0.1)':co.estado==='parcial'?'rgba(245,158,11,0.1)':'rgba(239,68,68,0.1)',color:co.estado==='pagado'?'#22C55E':co.estado==='parcial'?'#FCD34D':'#FCA5A5'}}>
                        {co.estado}
                      </span>
                    </td>
                    <td style={cs.td}>{co.fecha_pago?new Date(co.fecha_pago).toLocaleDateString('es-CO'):'-'}</td>
                    {esAdmin && <td style={cs.td}>
                      {co.estado!=='pagado' && (
                        <button style={{...cs.btn,...cs.btnG,padding:'5px 10px',fontSize:'12px'}} onClick={()=>setModalPago({...co,fecha_pago:new Date().toISOString().split('T')[0]})}>
                          ✓ Pagar
                        </button>
                      )}
                    </td>}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Tab rentabilidad */}
      {tabDetalle==='rentabilidad' && (
        <div style={cs.card}>
          <h2 style={cs.h2}>💰 Rentabilidad — {seleccionado?.nombre}</h2>
          {!rentabilidad ? (
            <p style={{color:'rgba(255,255,255,0.3)',textAlign:'center',padding:'30px'}}>No hay clientes asignados a esta red</p>
          ) : (
            <>
              {/* Totales */}
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(min(100%,160px),1fr))',gap:'14px',marginBottom:'20px'}}>
                {[
                  { label:'Total ingresos', valor: rentabilidad.total_ingresos, color:'#22C55E' },
                  { label:'Total costos red', valor: rentabilidad.total_costos, color:'#FCA5A5' },
                  { label:'Utilidad neta', valor: rentabilidad.total_utilidad, color: rentabilidad.total_utilidad >= 0 ? '#00E5FF' : '#EF4444' },
                ].map(st=>(
                  <div key={st.label} style={{...cs.card,marginBottom:0,textAlign:'center',padding:'16px'}}>
                    <div style={{fontSize:'20px',fontWeight:'800',color:st.color}}>{fmt(st.valor)}</div>
                    <div style={{fontSize:'12px',color:'rgba(255,255,255,0.45)',marginTop:'4px'}}>{st.label}</div>
                  </div>
                ))}
              </div>
              {/* Detalle por cliente */}
              <table style={cs.table}>
                <thead><tr>
                  <th style={cs.th}>Cliente</th>
                  <th style={cs.th}>Plan</th>
                  <th style={cs.th}>Estado</th>
                  <th style={cs.th}>Ingreso</th>
                  <th style={cs.th}>Costo red</th>
                  <th style={cs.th}>Utilidad</th>
                  <th style={cs.th}>Margen</th>
                </tr></thead>
                <tbody>
                  {rentabilidad.clientes.map(c=>(
                    <tr key={c.cliente_id}>
                      <td style={cs.td}><strong style={{color:'#fff'}}>{c.cliente}</strong></td>
                      <td style={cs.td}><span style={{fontSize:'11px',background:'rgba(255,255,255,0.06)',padding:'2px 8px',borderRadius:'10px',color:'rgba(255,255,255,0.5)'}}>{c.plan||'—'}</span></td>
                      <td style={cs.td}>
                        <span style={{fontSize:'11px',fontWeight:'600',color:c.estado==='activo'?'#22C55E':'#FCA5A5'}}>{c.estado}</span>
                      </td>
                      <td style={cs.td}><span style={{color:'#22C55E',fontWeight:'600'}}>{fmt(c.ingreso)}</span></td>
                      <td style={cs.td}><span style={{color:'#FCA5A5'}}>{fmt(c.costo)}</span></td>
                      <td style={cs.td}>
                        <span style={{fontWeight:'700',color:c.utilidad>=0?'#00E5FF':'#EF4444'}}>{fmt(c.utilidad)}</span>
                      </td>
                      <td style={cs.td}>
                        <span style={{fontSize:'12px',color:c.ingreso>0?(c.utilidad/c.ingreso*100).toFixed(0)+'%':'—', fontWeight:'600'}}>
                          {c.ingreso > 0 ? (c.utilidad/c.ingreso*100).toFixed(0)+'%' : '—'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )}

      {/* Modal editar (reutilizado) */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto'}}>
            <h2 style={{fontSize:'16px',fontWeight:'700',marginBottom:'20px',color:'#fff'}}>Editar proveedor</h2>
            {msg && <div style={{background:'rgba(239,68,68,0.1)',color:'#FCA5A5',padding:'10px',borderRadius:'8px',marginBottom:'14px',fontSize:'13px'}}>{msg}</div>}
            <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
              <div><label style={cs.label}>Nombre *</label><input style={cs.input} value={form.nombre} onChange={e=>f('nombre',e.target.value)}/></div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Contacto</label><input style={cs.input} value={form.contacto} onChange={e=>f('contacto',e.target.value)}/></div>
                <div><label style={cs.label}>Teléfono</label><input style={cs.input} value={form.telefono} onChange={e=>f('telefono',e.target.value)}/></div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Email</label><input style={cs.input} type="email" value={form.email} onChange={e=>f('email',e.target.value)}/></div>
                <div>
                  <label style={cs.label}>Tipo de red</label>
                  <select style={cs.input} value={form.tipo_red} onChange={e=>f('tipo_red',e.target.value)}>
                    {TIPOS_RED.map(t=><option key={t} value={t}>{t.charAt(0).toUpperCase()+t.slice(1)}</option>)}
                  </select>
                </div>
              </div>
              <div style={cs.grid2}>
                <div><label style={cs.label}>Tarifa por cliente ($/mes) *</label><input style={cs.input} type="number" value={form.tarifa_por_cliente} onChange={e=>f('tarifa_por_cliente',e.target.value)}/></div>
                <div><label style={cs.label}>Día de pago</label><input style={cs.input} type="number" min="1" max="28" value={form.dia_pago} onChange={e=>f('dia_pago',+e.target.value)}/></div>
              </div>
              <div><label style={cs.label}>Notas</label><textarea style={{...cs.input,minHeight:'70px',resize:'vertical'}} value={form.notas} onChange={e=>f('notas',e.target.value)}/></div>
            </div>
            <div style={{display:'flex',gap:'10px',marginTop:'20px',justifyContent:'flex-end'}}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>{setModal(false);setMsg('');}}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnP}} onClick={guardar} disabled={cargando}>{cargando?'Guardando...':'Guardar'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal pago */}
      {modalPago && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:500,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#0F1629',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'14px',padding:'28px',width:'100%',maxWidth:'400px'}}>
            <h2 style={{fontSize:'16px',fontWeight:'700',marginBottom:'16px',color:'#fff'}}>💳 Registrar pago</h2>
            <p style={{fontSize:'14px',color:'rgba(255,255,255,0.85)',marginBottom:'16px'}}>
              <strong>{seleccionado?.nombre}</strong> — {MESES[modalPago.periodo_mes]} {modalPago.periodo_anio}<br/>
              <span style={{fontSize:'18px',fontWeight:'700',color:'#F59E0B'}}>{fmt(modalPago.monto_total)}</span>
            </p>
            <div><label style={cs.label}>Fecha de pago</label>
              <input type="date" style={cs.input} value={modalPago.fecha_pago} onChange={e=>setModalPago(p=>({...p,fecha_pago:e.target.value}))}/>
            </div>
            <div style={{display:'flex',gap:'10px',marginTop:'20px',justifyContent:'flex-end'}}>
              <button style={{...cs.btn,...cs.btnW}} onClick={()=>setModalPago(null)}>Cancelar</button>
              <button style={{...cs.btn,...cs.btnG}} onClick={registrarPago}>✓ Confirmar pago</button>
            </div>
          </div>
        </div>
      )}
    </div>
    </Layout>
  );
}
